export default "__VITE_ASSET__dtFly8eY__"